<template>
  <div>
    <div class="card">
      <div class="card-header">
        <i class="fa fa-align-justify"></i>
        Rejestr zdarzeń
      </div>
      <div class="card-actions">
        <a href class="btn btn-secondary btn-sm" @click.prevent="toggleFiltersVisibility()">
          <span v-if="filtersVisible">Ukryj filtry</span>
          <span v-if="!filtersVisible">Pokaż filtry</span>
        </a>
      </div>
      <div class="card-filters" v-if="filtersVisible">
        <form @submit.prevent="searchList()">
          <div class="row">
            <div class="form-group col-md-2">
              <label for="qUserId">Użytkownik</label>
              <select class="form-control" id="qUserId" v-model="filters.qUserId">
                <option value=""></option>
                <option v-for="user in users"
                        v-bind:key="user.userId"
                        v-bind:value="user.userId">
                  {{ user.fullName }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-2">
              <label for="qAction">Zdarzenie</label>
              <select class="form-control" id="qAction" v-model="filters.qAction">
                <option value=""></option>
                <option v-for="action in actions"
                        v-bind:key="action"
                        v-bind:value="action">
                  {{ $t('logs.action.' + action) }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-2">
              <label for="qData">Szczegóły</label>
              <input class="form-control" v-model="filters.qData" id="qData" type="text"/>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12">
              <button type="submit" class="btn btn-primary">Szukaj</button>

              <button type="button" @click="clearFilters()" class="btn btn-link">Wyczyść filtry</button>
            </div>
          </div>
        </form>
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-bordered table-striped">
          <thead class="">
          <tr>
            <th scope="col">{{ $t('logs.date') }}</th>
            <th scope="col">{{ $t('logs.action') }}</th>
            <th scope="col">{{ $t('logs.userId')}}</th>
            <th scope="col">{{ $t('common.actions') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr class="loading" v-if="isLoading" v-bind:key="item"
              v-for="item in $store.state[paramsName].pageSize">
            <td v-bind:data-id="item"></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr v-if="!totalCount && !isLoading">
            <td colspan="4">
              Brak rekordów spełniających podane kryteria.
              Zmień lub <a href @click.prevent="clearFilters()">wyczyść filtry</a>.
            </td>
          </tr>
          <tr v-for="log in logs" v-if="!isLoading" :key="log.date" class="client-row">
            <td>{{ log.date | datetime }}</td>
            <td>{{ $t('logs.action.' + log.action) }}</td>
            <td>{{ log.userName }} ({{ log.userBranch }})</td>
            <td>
              <a href v-if="log.data" @click.prevent="showDetails(log)">Szczegóły</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <list-pager
          v-bind:params-name="paramsName"
          v-bind:total-count="totalCount"
          @reload="loadItems()">
      </list-pager>
    </div>
    <logs-details
        v-if="logDetails"
        @closed="closeDetails()"
        v-bind:details="logDetails">
    </logs-details>
  </div>

</template>

<script>
  import { logsService } from '@Service/logsService';
  import usersService from '@Service/users';
  import { toastError, listMixin } from '../helpers';
  import logsDetails from '@Component/logs-details';
  import listPager from '@Component/list-pager';

  export default {
    data: function () {
      return {
        paramsName: 'logsParams',
        logs: [],
        users: [],
        totalCount: 0,
        logDetails: null,
        filters: {},
        filtersVisible: false,
        isLoading: false,
        actions: [
          'USER_LOGIN',
          'TOGGLE_INVOICE_LOYALTY',
          'LOYALTYCARD_ADD',
          'CLIENT_MERGE',
          'CLIENT_UPDATE',
          'MANUAL_SYNC_APPROVE',
          'MANUAL_SYNC_SPLIT',
          'LOYALTYCARD_ADD_FAIL',
          'LOYALTYCARD_ASSIGN_USER',
          'LOYALTY_CARD_UPDATE_ACTIVE_STATUS',
          'CLIENT_UPDATE_ACTIVE_STATUS',
          'CLIENT_SEND_TO_PLAZA_SUCCESS',
          'MANUAL_SYNC_APPROVE_FAIL',
          'USER_CREATE',
          'USER_CHANGEPASS',
          'CLIENT_CONNECT',
          'STAYS_REPORT_REJECTED',
          'STAYS_REPORT_ERROR',
          'STAYS_REPORT_SUCCESS',
        ]
      };
    },
    mixins: [
      listMixin,
    ],
    components: {
      listPager,
      logsDetails,
    },
    methods: {
      showDetails: function (details) {
        this.logDetails = details;
      },
      closeDetails: function () {
        this.logDetails = null;
      },
      loadItems: function () {
        this.isLoading = true;
        logsService.getLogs(this.$store.state[this.paramsName])
          .then(response => {
            this.totalCount = parseInt(response.headers.totalcount, 10);
            this.logs = response.data.map(log => ({
              ...log,
              userName: this.usersById[log.userId] ? this.usersById[log.userId].fullName : log.userId,
              userBranch: this.usersById[log.userId] ? this.usersById[log.userId].branchName : '',
            }));
          })
          .catch(toastError)
          .then(() => this.isLoading = false);
      },
      getUsers: function () {
        this.isLoading = true;
        return usersService.getUserNames()
          .then(response => {
            this.users = response.data;
            this.usersById = Object.fromEntries(response.data.map(user => ([
              user.userId,
              user,
            ])));
          })
          .catch(toastError);
      },
      searchList: function () {
        this.$store.commit('setParams', {
          paramsName: this.paramsName,
          params: {
            ...this.filters,
            offset: 0,
          }
        });
        this.loadItems();
      },
      clearFilters: function () {
        this.filters = {
          qUserId: '',
          qAction: '',
          qData: '',
        };
        this.searchList();
      },
    },
    mounted: function () {
      this.filters = {
        qUserId: this.$store.state[this.paramsName].qUserId,
        qAction: this.$store.state[this.paramsName].qAction,
        qData: this.$store.state[this.paramsName].qData,
      };
      this.filtersVisible = this.$store.state[this.paramsName].filtersVisible;
      this.getUsers()
        .then(this.loadItems())
        .then(() => this.isLoading = false);
    },
  };
</script>
<style>

</style>